import { takeLatest, put, call } from 'redux-saga/effects';
import request from '../../components/Utils/httpHelper';
import * as localPartyMasterActions from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'

export function* localPartyMasterTemplateRequest(action) {
    let requestURL = `${CORE_API}/localparty/masters/template`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(localPartyMasterActions.localPartyMasterTemplateSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(localPartyMasterActions.localPartyMasterTemplateFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* localPartyMasterTemplate() {
    yield takeLatest(localPartyMasterActions.LOCAL_PARTY_MASTER_TEMPLATE_REQUEST, localPartyMasterTemplateRequest);
}

export function* submitLocalPartyMasterRequestSaga(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    let requestUrl = "";
    let methodtype = "";
    if(action.data.type === 'add'){
        methodtype="POST"
        requestUrl = `${CORE_API}/localparty/masters`;
    }
    if(action.data.type === 'edit'){
         methodtype="PUT"
        requestUrl = `${CORE_API}/localparty/masters`;
    }
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: methodtype, headers: HTTP_HEADERS_FORMDATA, responseType: 'blob' });
        
        // Check if response is JSON or Blob
        if (searchResult.data instanceof Blob && searchResult.data.type === 'application/json') {
            // It's a JSON blob, convert to JSON
            const text = yield searchResult.data.text();
            const jsonData = JSON.parse(text);
            yield put(localPartyMasterActions.addLocalPartyMasterUploadSuccess(jsonData));
        } else if (searchResult.data instanceof Blob) {
            // Binary response (shouldn't happen on success, but handle it)
            const text = yield searchResult.data.text();
            const jsonData = JSON.parse(text);
            yield put(localPartyMasterActions.addLocalPartyMasterUploadSuccess(jsonData));
        } else {
            // Direct JSON response
            yield put(localPartyMasterActions.addLocalPartyMasterUploadSuccess(searchResult.data));
        }
    } catch (err) {
        // Check if error response is Excel file or JSON
        if (err.response && err.response.data instanceof Blob) {
            const contentType = err.response.data.type;
            
            // Backend returns Excel errors as application/octet-stream
            if (contentType && (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || 
                contentType.includes('application/octet-stream'))) {
                // It's an Excel file - convert to ArrayBuffer
                const arrayBuffer = yield err.response.data.arrayBuffer();
                yield put(localPartyMasterActions.addLocalPartyMasterUploadFailureFile(arrayBuffer));
            } else if (contentType && contentType.includes('application/json')) {
                // It's a JSON error
                const text = yield err.response.data.text();
                const jsonError = JSON.parse(text);
                yield put(localPartyMasterActions.addLocalPartyMasterUploadFailure(jsonError));
            } else {
                // Unknown blob type, try to read as text
                const text = yield err.response.data.text();
                try {
                    const jsonError = JSON.parse(text);
                    yield put(localPartyMasterActions.addLocalPartyMasterUploadFailure(jsonError));
                } catch (parseErr) {
                    yield put(localPartyMasterActions.addLocalPartyMasterUploadFailure({ message: text || "Upload failed" }));
                }
            }
        } else {
            // Regular error message
            yield put(localPartyMasterActions.addLocalPartyMasterUploadFailure(err.response?.data || { message: "Upload failed" }));
        }
    }
}
export function* submitLocalPartyMasterRequest() {
    yield takeLatest(localPartyMasterActions.ADD_LOCAL_PARTY_MASTER_UPLOAD, submitLocalPartyMasterRequestSaga);
}


export function* localPartyMasterDataExcelRequest(action) {
    let requestURL = `${CORE_API}/localparty/masters/export`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(localPartyMasterActions.localPartyMasterDataExcelSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(localPartyMasterActions.localPartyMasterDataExcelFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* localPartyMasterDataExcel() {
    yield takeLatest(localPartyMasterActions.LOCAL_PARTY_MASTER_DATA_EXCEL_REQUEST, localPartyMasterDataExcelRequest);
}


export function* localPartyMasterListSaga(action) {
  const { pageNumber = DEFAULT_PAGE_NUMBER,pageSize = DEFAULT_PAGE_SIZE, filter = {},sorted = [{ id: "createdAt", desc: true }]} = action.data || {}

  const sortDirection = sorted.desc ? 'desc' : 'asc', sortField = sorted.id || 'createdAt'

 const requestURL = `${CORE_API}/localparty/masters/list/${pageNumber}/${pageSize}/sort/${sortField}/${sortDirection}`;
  try {
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: HTTP_HEADERS,
      data: filter
    });

    yield put(localPartyMasterActions.localPartyMasterListSuccess(response.data));
  } catch (err) {
    yield put(
      localPartyMasterActions.localPartyMasterListFailure(
        err.response?.data || { message: 'Failed to fetch Local Party Master list' }
      )
    );
  }
}

export function* fetchLocalPartyMasterList() {
    yield takeLatest(localPartyMasterActions.LOCAL_PARTY_MASTER_LIST_REQUEST, localPartyMasterListSaga);
}